import { useCallback, useEffect } from "react";
import { createTrackingUtils } from "../index";
import { useSelector } from "react-redux";
import { getSearchFetchStatus } from "../../../store/searchResults/selectors";
import useGlobalContext from "../../../hooks/useGlobalContext";

const util = createTrackingUtils({
  name: "flights_web_aa_filters_empty_search",
  defaultStage: 1,
  stages: {
    main: 1,
    filtrsUsed: 2,
    whileLoading: 3,
    exp: 4
  },
  goals: {}
});

export default function useFlightsWebAaFiltersEmptySearch() {
  const { experiments } = useGlobalContext();
  const searchFetchStatus = useSelector(getSearchFetchStatus);
  useEffect(() => {
    util.trackWithDefaultStage();
  }, []);
  const trackStages = useCallback(() => {
    util.stages.filtrsUsed();
    if (searchFetchStatus !== "loading") return;
    util.stages.whileLoading();
    if (!!experiments?.["flights_web_budget_layover_airports_filters"]) {
      util.stages.exp();
    }
  }, [searchFetchStatus, experiments]);
  return { trackStages };
}
